(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("classnames"), require("../popup"), require("../tools"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["classnames", "../popup", "../tools", "react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("classnames"), require("../popup"), require("../tools"), require("react")) : factory(root["classnames"], root["../popup"], root["../tools"], root["React"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE_classnames__, __WEBPACK_EXTERNAL_MODULE_rcm_mobile_components_popup__, __WEBPACK_EXTERNAL_MODULE_rcm_mobile_components_tools__, __WEBPACK_EXTERNAL_MODULE_react__) {
return 